module.exports = __webpack_public_path__ + "img/page-3_img06.b19dc6f2.jpg";